import { makeSx } from '@saas/lib/shared-utils'
import { defaultPalette } from '../../../../theme/idsTheme'

export default makeSx({
    PatientContainerHistorySectionLabel: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: '1rem',
        marginBottom: '1.5rem',
    },
    PatientContainerHistorySectionLabelIcon: {
        flexDirection: 'row',
        alignItems: 'center',
        background: defaultPalette.lightGrey.half,
        color: defaultPalette.typography.main,
        padding: '.5rem',
        borderRadius: '0.5rem',
    },
    PatientContainerHistorySectionLabelText: {
        fontSize: '1.3rem',
        fontWeight: 800,
    },
})
